import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/button'
import CustomModal from '../../../components/CustomModal'
import FileUpload from '../../../components/FileUpload'
import Input from '../../../components/input'
import Select from '../../../components/Select'
import { apiService } from '../../../services/apiService'
import { clearSingleUser, editUser, fetchUsersData, getSingleUser } from '../../../store/Slices/UserSlice'
import { editUserValidationSchema } from '../../../utils/Schema'
import { errorNotify, successNotify } from '../../../utils/toast'

const EditUser = ({ show, onHide, userId, currentPage, limit, searchFilters }) => {
    const dispatch = useDispatch();
    const { editLoading, singleUser, singleUserLoading } = useSelector((state) => state.users);

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [rolesDropdown, setRolesDropdown] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(false);

    useEffect(() => {
        if (show && userId) {
            dispatch(getSingleUser(userId));

            const fetchRoles = async () => {
                setRolesLoading(true);
                try {
                    const response = await apiService.getRolesDropdown();
                    const rawRoles = response?.data || response || [];
                    const rolesArray = Array.isArray(rawRoles) ? rawRoles : [];
                    setRolesDropdown(
                        rolesArray.map((r) => ({
                            value: r.id,
                            label: r.name,
                        }))
                    );
                } catch (error) {
                    console.error("Failed to fetch roles dropdown:", error);
                } finally {
                    setRolesLoading(false);
                }
            };

            fetchRoles();
        }

        return () => {
            if (!show) {
                dispatch(clearSingleUser());
            }
        };
    }, [show, userId, dispatch]);

    useEffect(() => {
        if (singleUser && singleUser?.image) {
            setUploadedFiles([{
                fileName: singleUser?.image,
                originalName: singleUser?.image,
                previewUrl: null,
                backend: true
            }]);
        }
    }, [singleUser])

    const initialValues = {
        name: singleUser?.username || '',
        email: singleUser?.email || '',
        role_id: singleUser?.my_role?.id || singleUser?.role?.id || singleUser?.role_id || '',
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const userData = {
                user_id: userId,
                name: values.name,
                role_id: Number(values.role_id),
                image: uploadedFiles[0]?.fileName || ''
            };

            await dispatch(editUser(userData)).unwrap();
            successNotify('User updated successfully');
            resetForm();
            onHide();
            setUploadedFiles([]);
            dispatch(fetchUsersData({
                page: currentPage,
                limit: limit,
                ...(searchFilters && { searchFilters: searchFilters })
            }));
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <CustomModal heading="Edit User" size="lg" show={show} handleClose={onHide}>
                {
                    singleUserLoading ? <div className='loading_spinner'><Spinner animation="grow" /></div> :
                        <Formik
                            initialValues={initialValues}
                            validationSchema={editUserValidationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize={true}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                                <Form>
                                    <div className='add_user_modal'>
                                        <h5>User Information</h5>

                                        <div>
                                            <Input
                                                label="Name"
                                                placeholder="Enter Full Name"
                                                type="text"
                                                name="name"
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.name}
                                                touched={touched.name}
                                            />
                                            <Input
                                                label="Email Address"
                                                placeholder="Enter Email Address"
                                                type="email"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                disabled={true}
                                                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                            />

                                            <hr />
                                        </div>

                                        <h5>User Role</h5>

                                        <div>
                                            <Select
                                                label="User Role"
                                                placeholder="Select User Role"
                                                options={rolesDropdown}
                                                loading={rolesLoading}
                                                name="role_id"
                                                value={rolesDropdown.find(role => role.value === values.role_id) || null}
                                                onChange={(selectedOption) => setFieldValue('role_id', selectedOption?.value || '')}
                                                onBlur={handleBlur}
                                                error={errors.role_id}
                                                touched={touched.role_id}
                                                isDisabled={singleUser?.my_role?.slug === "super-admin"}
                                            />
                                        </div>

                                        <div className='photo_document_section'>
                                            <FileUpload
                                                destination="add-user"
                                                files={uploadedFiles}
                                                setFiles={setUploadedFiles}
                                                maxFileSize={10}
                                                disabled={uploadedFiles.length >= 1}
                                            />
                                        </div>

                                        <div style={{ marginTop: "80px" }}>
                                            <Button
                                                cancelBtn={onHide}
                                                submitBtn={() => { }}
                                                loading={editLoading || isSubmitting}
                                                disabled={editLoading || isSubmitting}
                                                submitText="Update"
                                                type="submit"
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                }
            </CustomModal>
        </div>
    )
}

export default EditUser